import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords don't match"); return; }
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — please log in");
      navigate("/login");
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <form onSubmit={submit} className="w-full max-w-sm border border-border rounded-md bg-white p-8" data-testid="reset-form">
        <h1 className="font-heading font-black text-2xl text-sapphire">Choose a new password</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-6">At least 8 characters.</p>
        {!token && <div className="mb-4 text-sm bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded" data-testid="reset-missing-token">This reset link is missing its token. Request a new one.</div>}
        {error && <div className="mb-4 text-sm bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded" data-testid="reset-error">{error}</div>}
        <div className="space-y-4">
          <div>
            <Label className="uppercase text-xs tracking-[0.2em] mb-1.5 block">New password</Label>
            <Input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" />
          </div>
          <div>
            <Label className="uppercase text-xs tracking-[0.2em] mb-1.5 block">Confirm password</Label>
            <Input type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" />
          </div>
        </div>
        <Button type="submit" disabled={loading || !token} className="w-full mt-6 bg-ocean hover:bg-ocean/90" data-testid="reset-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}
        </Button>
        <p className="text-sm text-center mt-6 text-muted-foreground"><Link to="/forgot-password" className="text-ocean font-semibold">Request a new link</Link></p>
      </form>
    </div>
  );
}
